import { printf } from 'fast-printf'

export const variableConverter = (format: string, variable: string | number) => {
  return printf(format, variable)
}
